import React, { useState } from "react";
import api from "../../utils/api";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Box,
  Divider,
  Switch,
  FormControlLabel,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Lock, Notifications } from "@mui/icons-material";
import {
  successAlert,
  errorAlert,
  loadingAlert,
  closeAlert,
} from "../../utils/swalConfig";

const Settings = () => {
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    password: "",
    passwordConfirm: "",
  });

  const [notifications, setNotifications] = useState({
    email: true,
    withdrawal: true,
    deposit: true,
    referral: true,
  });

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    try {
      if (passwordForm.password !== passwordForm.passwordConfirm) {
        return errorAlert("Error", "Passwords do not match");
      }

      loadingAlert("Updating password...");
      const token = localStorage.getItem("jwt");
      await api.patch("/users/updateMyPassword", passwordForm, {
        headers: { Authorization: `Bearer ${token}` },
      });

      closeAlert();
      await successAlert("Success!", "Password updated successfully");
      setPasswordForm({
        currentPassword: "",
        password: "",
        passwordConfirm: "",
      });
    } catch (err) {
      closeAlert();
      errorAlert(
        "Error",
        err.response?.data?.message || "Failed to update password"
      );
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", py: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Lock sx={{ mr: 2, color: "primary.main" }} />
                <Typography variant="h6">Change Password</Typography>
              </Box>
              <form onSubmit={handlePasswordChange}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="password"
                      label="Current Password"
                      value={passwordForm.currentPassword}
                      onChange={(e) =>
                        setPasswordForm({
                          ...passwordForm,
                          currentPassword: e.target.value,
                        })
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="password"
                      label="New Password"
                      value={passwordForm.password}
                      onChange={(e) =>
                        setPasswordForm({
                          ...passwordForm,
                          password: e.target.value,
                        })
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="password"
                      label="Confirm New Password"
                      value={passwordForm.passwordConfirm}
                      onChange={(e) =>
                        setPasswordForm({
                          ...passwordForm,
                          passwordConfirm: e.target.value,
                        })
                      }
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button variant="contained" type="submit" sx={{ mt: 2 }}>
                      Update Password
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Notifications sx={{ mr: 2, color: "primary.main" }} />
                <Typography variant="h6">Notification Settings</Typography>
              </Box>
              <Grid container spacing={2}>
                {Object.entries(notifications).map(([key, value]) => (
                  <Grid item xs={12} key={key}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={value}
                          onChange={(e) =>
                            setNotifications({
                              ...notifications,
                              [key]: e.target.checked,
                            })
                          }
                        />
                      }
                      label={`${
                        key.charAt(0).toUpperCase() + key.slice(1)
                      } notifications`}
                    />
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Settings;
